module.exports = __webpack_public_path__ + "img/iphone69_screenshot-2.52a7574b.jpeg";